module.exports = require("@material-ui/icons/TableChart");